import { generatePath, Link } from "react-router";
import Ellipsis from "../../../common/components/views/Ellipsis";
import { COMMISSIONS_BATCH_ROUTE_PATHS } from "../batch/paths";
import { removeBatchNameCustomSuffix } from "../batch/utils";

type Props = {
  showLink?: boolean;
  batchName: string;
  batchId: string;
};

export const CommissionBatchName = ({ showLink, batchName, batchId }: Props) => {
  return showLink ? (
    <Ellipsis tooltip={batchName}>
      <Link to={generatePath(COMMISSIONS_BATCH_ROUTE_PATHS.detail.to, { id: batchId })} target="_blank">
        {batchName}
      </Link>
    </Ellipsis>
  ) : (
    <Ellipsis>{removeBatchNameCustomSuffix(batchName)}</Ellipsis>
  );
};
